import React,{useState, useEffect} from 'react'
import './styles/problems.css'
import {db,auth } from './firebase'
import Problem from './problem'
import {Link, Redirect} from 'react-router-dom'


export default function Problems() {
    const[userId,setUserId]=useState(null)
    const [loading,setLoading]=useState(true)
    const [loggedIn, setLoggedIn]=useState(false)
    const [problemList, setProblemList]=useState([])
    let problemlist=[]



    //===================================================================
    //
    //toggling the bar
    //
    //===================================================================
    const openDrawer=()=>{
        const drawer=document.querySelector('.drawer')
        drawer.classList.toggle('open-drawer')
        //console.log('done')
    }



   
    //===================================================================
    //
    //  Getting data from the database
    //
    //===================================================================
    const getUserInfo =()=>{
        auth.onAuthStateChanged(user=>{
            if (user){
                setUserId(user)
                setLoggedIn(true)
                //accessing db and finding the files and getting the handle
                db.collection(user.email).doc('data').collection('problems').get()
                    .then(res=>{
                        res.docs.forEach(a=>{
                            console.log(a.data())
                            problemlist.push(a.data())  
                        })
                    })
                    .then(()=>{
                        setLoading(false)
                        setProblemList(problemlist)

                    })
                
                
                
            }
            else{
                alert('Login please!')
                setLoggedIn(false)
            }
        })  
    }
    useEffect(()=>getUserInfo(),[])
    
    //===================================================================
    //
    //  Adding problem to the database
    //
    //===================================================================
    const addProblem=()=>{
        let ct_id=document.querySelector('#ct_id').value
        let prb_id=document.querySelector('#prb_id').value
        let rating=document.querySelector('#rating').value
        let prb_name=document.querySelector('#prb-name').value
        let doc_name=ct_id+prb_id

        //saving the data to firebase
        db.collection(userId.email).doc('data').collection('problems').doc(doc_name).set({
            name:prb_name,
            contest_id:ct_id,
            prob_id:prb_id,
            rating:rating,
            url:`http://codeforces.com/problemset/problem/${ct_id}/${prb_id}`

        })
        //re-running the data fetching
        getUserInfo()
        //clearing the input fields
        document.querySelector('#ct_id').value=''
        document.querySelector('#prb_id').value=''
        document.querySelector('#rating').value=''
        document.querySelector('#prb-name').value=''
    }
         
    //===================================================================
    //
    //  Creating The loading Screen
    //
    //===================================================================
    if (loading){
        return(
            <div className="loading-screen">
            <i class="material-icons loading"> hourglass_empty</i>
            <p>Loading......</p>
            </div>
        );
    }
    if(!loggedIn){
        return(<Redirect to='/'/>)
    }
    else{
        return (
        <div>
            <div className="navbar">
                <h3>Codeforces tracked</h3>
                <i class="material-icons md-64" onClick={openDrawer}>menu</i>
                <ul class='drawer'>
                    <Link to='/home' style={{textDecoration:'none', color:'black'}}><li>My Account</li></Link>
                    <Link to='/problems'style={{textDecoration:'none', color:'black'}}><li>Saved Problems</li></Link>
                    <Link to='/submissions' style={{textDecoration:'none', color:'black'}}><li>Submissions</li></Link>
                    <Link to='/friends' style={{textDecoration:'none', color:'black'}}><li>Track friends</li></Link>
                    <li>Upcoming</li>
                    <li onClick={()=>auth.signOut()}>Log Out</li>
                </ul>
            </div>
            <div className="title">
                <h1>Saved Problems</h1>
            </div>
            <div className="inputs-problems">
                <input type="number" id='ct_id' placeholder='Contest Id'/>
                <input type="text" id='prb_id' placeholder='Problem Id'/>
                <input type="number" id="rating" placeholder='Rating'/>
                <input type="text" id='prb-name' placeholder='Problem Name'/>
                <i class="material-icons" id='add' onClick={addProblem}>add_box</i>
            
            </div>

            <div className="main-container">
                {problemList.map(a=>{
                    return(
                        <Problem key={a.name} problem={a} email={userId.email}/>
                    )
                })}
                
            </div>
            
        </div>
    )


    }

    
}
